<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="User" />
      <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg">
        <div id="table-header" class="mb-5 flex justify-between">
          <AddButton to_url="/user/tambah-user" button_text="+ Tambah User" button_class="text-base py-2 font-medium" />
        </div>
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Name</TableHeadCell>
                    <TableHeadCell>Email</TableHeadCell>
                    <TableHeadCell>Role</TableHeadCell>
                    <TableHeadCell>Phone Number</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="allUsers.length == 0">
                    <TableCell colspan="8" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(user, index) in allUsers" :key="user.id" :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ user.name }}</TableCell>
                    <TableCell>{{ user.email }}</TableCell>
                    <TableCell>
                      <span :class="{
                        'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-300': user.role === 'Kasir',
                        'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300': user.role === 'Kitchen',
                        'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-300': user.role === 'Admin'
                      }" class="px-2 py-1 rounded-full text-xs font-medium">
                        {{ getRoles(user.role_id)?.name }}
                      </span>
                    </TableCell>
                    <TableCell>{{ user.phone }}</TableCell>
                    <TableCell noTextColor customClass="text-gray-500 dark:text-gray-400 flex">
                      <RouterLink :to="'/user/edit-user/' + user.id" custom v-slot="{ navigate }">
                        <button @click="navigate" :id="'edit-data-' + user.id"
                          class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                          <PencilSquareIcon class="h-4 w-4 group-hover:text-green-700" />
                        </button>
                      </RouterLink>
                      <!-- <button :id="'delete-data-' + user.id"
                        class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                      </button> -->
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
              <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from "@/views/IndexView.vue";
import PageTitle from "@/components/PageTitle.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import { PencilSquareIcon } from "@heroicons/vue/24/solid";
import PaginationButtons from "@/components/PaginationButtons.vue";
import { mapGetters } from "vuex";
import { Button, ConfirmDialog, Toast } from "primevue";

export default {
  name: "UserView",
  components: {
    IndexView,
    PageTitle,
    AddButton,
    ViewContainer,
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
    PencilSquareIcon,
    PaginationButtons,
    Toast,
    ConfirmDialog,
    Button
  },
  data() {
    return {
      // allUsers:[
      //   {
      //     id: 1,
      //     name: 'Kasir 1',
      //     email: 'kasir1@fox.id',
      //     role: 'Kasir',
      //     username: 'kasir1',
      //     address: 'Jl. Jend. Sudirman No. 1, Jakarta Selatan',
      //     phone_number: '08123456789',
      //     password: 'password123',
      //   },
      //   {
      //     id: 2,
      //     name: 'Kitchen 1',
      //     email: 'kicthen1@fox.id',
      //     role: 'Kitchen',
      //     username: 'kitchen1',
      //     address: 'Jl. Jend. Sudirman No. 1, Jakarta Selatan',
      //     phone_number: '08123456789',
      //     password: 'password123',
      //   },
      //   {
      //     id: 3,
      //     name: 'Kasir 2',
      //     email: 'kasir2@fox.id',
      //     role: 'Kasir',
      //     username: 'kasir2',
      //     address: 'Jl. Jend. Sudirman No. 1, Jakarta Selatan',
      //     phone_number: '08123456789',
      //     password: 'password123',
      //   }
      // ],
      modalShowUnit: false,
      isBlur: false,
      selectedUnit: null,
      currentPage: 1,
      totalPages: 1,
    }
  },
  computed: {
    ...mapGetters('users', ['allUsers']),
    ...mapGetters('roles', ['allRoles']),
  },
  async created() {
    this.$store.dispatch('roles/fetchRoles')
    this.fetchUsers();
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchUsers({ page: newVal });
      },
    }
  },
  methods: {
    async fetchUsers(params = {}) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = 50;
      try {
        const { pagination } = await this.$store.dispatch('users/fetchUsers', params);
        if (pagination) {
          this.totalPages = pagination.totalPages;
        }
      } catch (error) {
        console.log(error);
      }
    },
    showModal() {
      this.modalShowUnit = true;
      this.isBlur = true;
      this.selectedUnit = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowUnit = false;
        this.isBlur = false;
      }, 200);
    },
    getRoles(roleId) {
      const role = this.allRoles.find(role => role.id === roleId);
      return role ? role : 'Tidak ada role';
    },
  }
}
</script>